import { useState, useEffect } from 'react';
import { XMarkIcon, ArrowUpOnSquareIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const PWAInstallGuide = ({ isVisible, onClose, orgName, orgLogo }) => {
	console.log('PWAInstallGuide visible', isVisible);
	const [isIOS, setIsIOS] = useState(false);
	const [isAndroid, setIsAndroid] = useState(false);

	useEffect(() => {
		const userAgent = navigator.userAgent || window.opera;
		setIsIOS(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
		setIsAndroid(/android/i.test(userAgent));
	}, []);

	const getInstructions = () => {
		if (isIOS) {
			return (
				<div className="space-y-3">
					<p className="text-base-600 text-sm">
						Tap the <ArrowUpOnSquareIcon className="mx-1 inline h-4 w-4" />{' '}
						share button below, then select{' '}
						<span className="font-semibold">
							&quot;Add to Home Screen&quot;
						</span>
					</p>
				</div>
			);
		} else if (isAndroid) {
			return (
				<div className="space-y-3">
					<p className="text-base-600 text-sm">
						Tap the menu button (⋮) in your browser, then select{' '}
						<span className="font-semibold">
							&quot;Add to Home screen&quot;
						</span>{' '}
						or <span className="font-semibold">&quot;Install app&quot;</span>
					</p>
				</div>
			);
		} else {
			return (
				<div className="space-y-3">
					<p className="text-base-600 text-sm">
						Use your browser&apos;s menu to{' '}
						<span className="font-semibold">
							&quot;Add to Home Screen&quot;
						</span>{' '}
						or <span className="font-semibold">&quot;Install&quot;</span> this
						app.
					</p>
				</div>
			);
		}
	};

	if (!isVisible) return null;

	return (
		<>
			{/* Backdrop */}
			<div
				className="fixed inset-0 z-50 bg-black bg-opacity-50 transition-opacity duration-300"
				onClick={onClose}
			/>

			{/* Modal */}
			<div className="pwa-install-guide fixed inset-x-0 bottom-0 z-50">
				<div className="rounded-t-2xl border-t border-gray-200 bg-base-100 shadow-xl">
					{/* Header */}
					<div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
						<div className="flex items-center space-x-3">
							<div className="bg-base-900 flex h-10 w-10 items-center justify-center rounded-lg">
								<img
									src={orgLogo || '/connected-logo.png'}
									alt="App Logo"
									className="h-6 w-6"
									onError={(e) => {
										e.target.style.display = 'none';
									}}
								/>
							</div>
							<div>
								<h3 className="text-base-900 text-lg font-semibold">
									Install {orgName || 'Connect Platform'}
								</h3>
								<p className="text-base-500 text-sm">
									Get the full app experience
								</p>
							</div>
						</div>
						<button
							onClick={onClose}
							className="rounded-full p-2 transition-colors hover:bg-base-100"
						>
							<XMarkIcon className="text-base-400 h-5 w-5" />
						</button>
					</div>

					{/* Content */}
					<div className="px-6 py-4">{getInstructions()}</div>

					{/* Safe area padding for iPhone */}
					<div className="pb-safe" />
				</div>
			</div>
		</>
	);
};

PWAInstallGuide.propTypes = {
	isVisible: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	orgName: PropTypes.string,
	orgLogo: PropTypes.string,
};

export default PWAInstallGuide;
